import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CustomValidators } from '../../customValidators/validator';
import { Language } from 'src/app/api/invoice/models';

@Component({
  selector: 'app-work-order-summary-filter',
  templateUrl: './work-order-summary-filter.component.html',
  styleUrls: ['./work-order-summary-filter.component.scss'],
})
export class WorkOrderSummaryFilterComponent {
  filterForm!: FormGroup;
  Language = Language;
  constructor(
    public dialogRef: MatDialogRef<WorkOrderSummaryFilterComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      callbackMethod: (form: any) => void;
      type: string;
    },
    private fb: FormBuilder
  ) {
    this.createForm();
  }

  createForm() {
    this.filterForm = this.fb.group(
      {
        language: [Language.English, Validators.required],
        fromDate: ['', Validators.required],
        toDate: ['', Validators.required],
        isDeadHead: [true],
        isFlightTime: [true],
        isLayoverTime: [true],
        isWaitingTime: [true],
      },
      {
        validator: CustomValidators.normalDateRangeValidator(
          'fromDate',
          'toDate'
        ),
      }
    );
  }

  // normalDateRangeValidator

  onCancelClick(): void {
    this.dialogRef.close({ success: 'false' });
  }

  onSubmit() {
    if (this.filterForm.valid) {
      const formData = this.filterForm.value;
      if (this.data && this.data.callbackMethod) {
        this.data.callbackMethod(formData);
        this.dialogRef.close({ success: 'true' });
      }
    }
  }
}
